import { Chip } from '@fukku/chip'

import type { TransitionEvent } from 'react'
import { cx } from 'utils/cx'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'
import type { InitIceBreakersMessage } from '../../types/messageTypes'
import styles from './IceBreakers.module.scss'

export const IceBreakers = ({
	message,
}: {
	readonly message: InitIceBreakersMessage
}) => {
	const { shouldFadeoutMessages, deleteChoices, sendHumanMessage } =
		useChatBotMessages()
	const iceBreakers = message.value

	const handleIceBreakerClick = (iceBreaker: string) => {
		sendHumanMessage({ messageContent: iceBreaker })
	}

	const onIceBreakersTransitionEnd = (e: TransitionEvent<HTMLDivElement>) => {
		if (e.propertyName === 'opacity') {
			deleteChoices()
		}
	}

	return (
		<div
			className={cx(
				styles.iceBreakersContainer,
				shouldFadeoutMessages && styles.hidden
			)}
			onTransitionEnd={onIceBreakersTransitionEnd}
		>
			{iceBreakers.map((iceBreaker) => (
				<Chip
					key={`${iceBreaker}`}
					name={iceBreaker}
					handleClick={() => handleIceBreakerClick(iceBreaker)}
					className={styles.chip}
				/>
			))}
		</div>
	)
}
